"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@chakra-ui/react");
var _chevronDown = _interopRequireDefault(require("@spothero/icons/chevron-down"));
var _Icon = _interopRequireDefault(require("../../Icon/Icon"));
var _FormControl = _interopRequireDefault(require("../FormControl"));
var _excluded = ["label", "helperText", "errorMessage", "isInvalid", "isDisabled", "isRequired", "isOptional", "rightElement", "leftElement", "rightElementStyles", "leftElementStyles"];
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
//For select left is static arrow,
/**
 * A component used in the homepage/midfunnel refresh of 2024
 * Initially built as purpose built as possible with hopes of extending it to other systems
 * using `<RefreshedSelect><option value="1"/>/<RefreshedSelect>` will bring in the core of this.
 * Left arrow is static for this select.  You can pass a second left element in but it will not over write the down arrow currently
 */
var Select = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var label = _ref.label,
    helperText = _ref.helperText,
    errorMessage = _ref.errorMessage,
    isInvalid = _ref.isInvalid,
    isDisabled = _ref.isDisabled,
    isRequired = _ref.isRequired,
    isOptional = _ref.isOptional,
    rightElement = _ref.rightElement,
    leftElement = _ref.leftElement,
    rightElementStyles = _ref.rightElementStyles,
    leftElementStyles = _ref.leftElementStyles,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var classes = (0, _classnames["default"])({
    'FormElement-contains-error': isInvalid
  });
  return /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
    isInvalid: isInvalid,
    isDisabled: isDisabled,
    isRequired: isRequired,
    errorMessage: errorMessage,
    helperText: helperText,
    label: label,
    id: props.id,
    rightElement: rightElement,
    leftElement: leftElement,
    rightElementStyles: rightElementStyles,
    leftElementStyles: leftElementStyles
  }, /*#__PURE__*/_react["default"].createElement(_react2.Select, (0, _extends2["default"])({
    icon: /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      as: _chevronDown["default"]
    }),
    iconSize: 20,
    fontWeight: "medium",
    fontSize: "sm",
    ref: ref,
    className: classes,
    variant: "refreshed"
  }, props)));
});
var _default = exports["default"] = Select;